import _extends from '/app/node_modules/babel-runtime/helpers/extends';
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as stepperComponents from '~/components/stepper';
import progressMovil from '~/components/progress-movil';
import ProgressLine from '~/components/dashboard/progress-line';
import { SaveAfiliation, NotAffiliationFinalized } from '~/components/modals';
import { mapState, mapGetters } from 'vuex';

export default {
    props: {
        data: Array,
        render: Boolean
    },
    layout: 'stepped',
    components: _extends({}, stepperComponents, {
        progressMovil: progressMovil,
        SaveAfiliation: SaveAfiliation,
        NotAffiliationFinalized: NotAffiliationFinalized,
        ProgressLine: ProgressLine
    }),
    data: function data() {
        return {
            loading: false,
            pagination: 0
        };
    },

    methods: {},
    computed: {
        isMovil: function isMovil() {
            return this.$vuetify.breakpoint.name == 'md' || this.$vuetify.breakpoint.name == 'sm' || this.$vuetify.breakpoint.name == 'xs';
        }
    },
    mounted: function mounted() {
        // this.scroll()
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shared/affiliations-mobile-table.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shared/affiliations-mobile-table.vue
// module chunks = 0 1